<template>
  <div
    class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
  >
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="sendMailShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"
          ><i class="fas fa-paper-plane"></i
        ></span>
        <span class="p-l-20 p-r-10">Send Access Problem</span>
      </button>
    </div>
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="addShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
        <span class="p-l-20 p-r-10">Add Hotel</span>
      </button>
    </div>
  </div>
  <dataTable
    :name="'CustomerHotels'"
    ref="agGrid"
    :columnDefs="columnDefs"
    :data="data"
    :addContextMenuItem="getContextMenuItems"
    @cellClicked="updateShow = $event.data.Id"
    :rowClassRules="{
      // row style function
      error: (params) => {
        // var numSickDays = params.data;
        return params?.data?.SyncError;
      },
    }"
  ></dataTable>
  <modal
    size="lg"
    title="Error"
    v-if="errorOpen != null"
    @close="errorOpen = null"
  >
    <template #content>
      <pre class="m-0">{{ errorOpen.SyncErrorMessage }}</pre>
    </template>
  </modal>
  <upsert
    v-if="addShow || updateShow > 0"
    :CustomerId="setModel.Id"
    @add="$refs.agGrid.addRow([$event])"
    @update="$refs.agGrid.changeRow('Id', $event)"
    :setModel="updateShow"
    @close="
      addShow = false;
      updateShow = 0;
    "
  ></upsert>
  <sendAccessProblem
    :setModel="setModel"
    v-if="sendMailShow"
    @close="sendMailShow = false"
  ></sendAccessProblem>
  <emails v-if="emailPop != null" :hotel="emailPop" @close="emailPop = null">
  </emails>
</template>

<script>
import upsert from "./upsert";
import sendAccessProblem from "./../sendAccessProblem.vue";
import emails from "./emails/main.vue";
import moment from "moment";
export default {
  name: "users",
  components: { upsert, sendAccessProblem, emails },
  props: {
    setModel: Object,
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 3,
          minWidth: 120,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "RoomCount",
          filter: "agNumberColumnFilter",
          field: "RoomCount",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "PMSIntegration",
          width: 140,
          filter: false,
          field: "PMSIntegration",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "LastSyncTime",
          width: 140,
          filter: "agTextColumnFilter",
          field: "LastSyncTime",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
            }
          },
        },
      ],
      sendMailShow: false,
      errorOpen: null,
      data: null,
      addShow: false,
      updateShow: 0,
      emailPop: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`CustomerHotels/` + this.setModel.Id)
      .then((response) => {
        this.data = response.data;
        this.detailShow = this.data[0];
      });
  },
  methods: {
    sync(item) {
      this.$appAxios
        .get(`PMS/UpdateReservationDetailFormNeeds/` + item.Id)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Başarılı",
            text: "Formneeds başarı ile güncellendi",
            timer: 2000,
            confirmButtonText: "Tamam",
          });
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Formneeds güncellenemedi!",
            text: err.response.data,
            confirmButtonText: "Tamam",
          });
          this.$isError(err);
        });
    },
    createServiceAccount(item) {
      this.$appAxiosAdmin
        .get("hotels/" + item.Id + "/CreateServiceAccount")
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Başarılı",
            text: "Servis başarı ile oluşturuldu",
            timer: 2000,
            confirmButtonText: "Tamam",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    loginHotelServiceAccount(item) {
      this.$appAxiosAdmin
        .get("hotels/" + item.Id + "/LoginHotelServiceAccount")
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Başarılı",
            text: "Servis başarı ile login olundu!",
            timer: 2000,
            confirmButtonText: "Tamam",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the customer hotel named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`CustomerHotels/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer hotel has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Emails",
          icon: "<i class='fas fa-envelope'></i>",
          action: () => {
            this.emailPop = params.node.data;
          },
        },
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updateShow = params.node.data.Id;
          },
        },
        {
          name: "Create Service Account",
          icon: '<i class="mdi mdi-json"></i>',
          action: () => {
            this.createServiceAccount(params.node.data);
          },
        },
        {
          name: "Login Service Account",
          icon: '<i class="mdi mdi-json"></i>',
          action: () => {
            this.loginHotelServiceAccount(params.node.data);
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>
